<div id="price-charts-container">
  <ag-charts-angular
    id="price-chart"
    [options]="priceChartOptions"
    class="price-chart"
  ></ag-charts-angular>
  <ag-charts-angular
    id="yield-chart"
    [options]="yieldChartOptions"
    class="price-chart"
  ></ag-charts-angular>
  <ag-charts-angular
    id="duration-chart"
    [options]="durationChartOptions"
    class="price-chart"
  ></ag-charts-angular>
</div>
